export const typeStrategy = {
  'Geo::City': 'Cidade',
  'Geo::Group': 'Grupo',
  'Geo::Country': 'País',
  'Geo::Region': 'Região',
  'Geo::State': 'Estado',
}
